// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bb-2";
export var aiChatCartContainerExit = "_bb-4";
export var aiChatContainerLarge = "_bb-0";
export var aiChatContainerSmall = "_bb-1";
export var aiChatIcon = "_bb-6";
export var slideInFromRight = "_bb-3";
export var slideOutToRight = "_bb-5";